<script lang="ts">
	export let chartData: number[] | string[];
	export let isEqual = false; // NOTE: bitcoin/eth currency case
	export let dayChangeSync: number;

	let points;
	let polygonPoints;
	let trend: { trend: string; accent: string; blurred: string };
	if (chartData[chartData.length - 1] === null) {
		chartData.pop();
	}

	const colors = {
		orange: '#ED6C4D',
		orangeDark: 'rgba(237, 108, 77, 0.3)',
		green: '#4B8185',
		greenDark: 'rgba(75, 129, 133, 0.2)',
		yellow: '#E3A400',
		yellowDark: 'rgba(255, 185, 4, 0.2)',
	};

	function getTrendDirectionColor(
		dayChangeSync: number,
		data: Array<number | string>,
		isBtcOrEth = false,
	) {
		let result;
		if (isBtcOrEth) {
			result = 0;
		} else if (dayChangeSync) {
			result = dayChangeSync;
		} else {
			const start = Number(data[0]);
			const end = Number(data[data.length - 1]);
			result = start - end;
		}

		if (result < 0) {
			return { accent: colors.orange, blurred: colors.orangeDark, trend: 'down' };
		}
		if (result > 0) {
			return { accent: colors.green, blurred: colors.greenDark, trend: 'up' };
		}
		if (result === 0) {
			return { accent: colors.yellow, blurred: colors.yellowDark, trend: 'stable' };
		}
	}

	function createChart(data: Array<number | string>) {
		if (isEqual) {
			points = '0 25, 150 25';
			polygonPoints = `0 50, ${points}, 150 150`;
		} else {
			const chartLength = data.length - 1;
			const widthPx = 150 / chartLength;
			// @ts-ignore
			const min = Math.min(...data);
			// @ts-ignore
			const max = Math.max(...data);
			points = data.reduce((accum, value, index) => {
				const x = index * widthPx;
				const diff = max - min;
				// @ts-ignore
				const y = ((value - min) / (diff === 0 ? 1 : diff)) * -30 + 45;
				if (index) return `${accum} ${x},${y}`;
				return `${x},${y}`;
			}, '');
			polygonPoints = `0 50, ${points}, 150 50`;
		}
	}

	$: chartData.length > 0 && createChart(chartData);
	$: {
		trend = getTrendDirectionColor(dayChangeSync, chartData, isEqual);
	}
</script>

{#key chartData}
	<svg height="50px" width="150px" xmlns="http://www.w3.org/2000/svg">
		<polyline {points} style={`fill:none;stroke:${trend.accent};stroke-width:1`} />
		<polygon points={polygonPoints} style={`fill:${trend.blurred};stroke-width:0`} />
	</svg>
{/key}
